import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { PersonalLineupQueryData } from './types';

export function setPersonalLineupQueryData(personalLineupData: PersonalLineupQueryData) {
  return queryClient.setQueryData<PersonalLineupQueryData>(queryKeys.personalLineup, personalLineupData);
}
